export default {"src":"/_next/static/media/arrow-down.75b407f9.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};